import React, { useState } from "react";
import Select from "react-select";

import classNames from "classnames";

import { useRatingsContext } from "../contexts/Ratings";
import useRatingsHandlers from "../hooks/useRatingsHandlers";

import Loading from "../../../../../components/Loading";
import { selectYears } from "../../../../../features/leaguemgmt/leagueManagementSlice";
import { useAppSelector } from "../../../../../hooks/reduxHooks";

const PageHeader = (): React.JSX.Element => {
    const [year, setYear] = useState<number | undefined>(undefined);
    const years = useAppSelector(selectYears);
    const { handleYearChange } = useRatingsHandlers();

    return (
        <div
            className={classNames("d-flex align-items-center mb-2")}
            data-testid="ratingsPageHeader"
        >
            <h2 className={classNames("mb-0")}>
                {year || "All Years'"} Ratings
            </h2>
            <div
                style={{
                    marginLeft: "auto",
                }}
            >
                <Loading
                    className="mx-3 w-auto"
                    useContext={useRatingsContext}
                />
            </div>
            <h3
                id="selectYear"
                style={{
                    marginBottom: 0,
                    paddingRight: ".25em",
                }}
            >
                Select Year:
            </h3>
            <div data-testid="selectYear">
                <Select
                    isSearchable={false}
                    isClearable={true}
                    isMulti={false}
                    aria-labelledby="selectYear"
                    options={
                        years &&
                        Array.from(Object.keys(years)).map(y => {
                            return {
                                value: y,
                                label: y,
                            };
                        })
                    }
                    onChange={y => {
                        const year = y ? parseInt(y?.value) : undefined;
                        setYear(year);
                        handleYearChange(year);
                    }}
                />
            </div>
        </div>
    );
};

export default PageHeader;
